export default "__VITE_ASSET__496cb575__"